module.exports = __webpack_public_path__ + "img/18afd5bc7071e8b368ab0dad26c6347c.png";